import gql from 'graphql-tag';

export const ExportIncidents = gql`
  mutation ExportIncidents($organizationId: ID!, $request: GetPaginatedIncidentsRequest) {
    exportIncidents(organizationId: $organizationId, request: $request) {
      id
      name
      state
      createdOn
      startedOn
      completedOn
      response
    }
  }
`;
